<template>
  <div class="bottom">
    <div style="height:20%;">
      <div class="flex" style="height:100%">
        <div class="chart" ref="chart1"></div>
        <div class="chart" ref="chart2"></div>
        <div class="chart" ref="chart3"></div>
      </div>
    </div>
    <div class="xmjd">
      <div class="jdChart" ref="chart"></div>
    </div>
    <div class="areaText" v-show="graphic.completion !== 0">
      <el-timeline>
        <el-timeline-item
          timestamp=""
          placement="top"
          v-for="(item, index) in list"
          :key="index"
        >
          <el-card>
            <div class="jdtDiv flex">
              <span>
                {{ item.year }}年<span v-if="item.month < 10">0</span
                >{{ item.month }}月
              </span>
              <div class="jdt flex">
                <el-progress :percentage="item.completion"></el-progress>
              </div>
            </div>
            <div class="wzDiv" v-if="item.dataProject.info != ''">
              {{ item.dataProject.info }}
            </div>
            <div
              class="imgArr flex"
              v-if="item.dataProject.url != '' && item.dataProject.url != null"
            >
              <div class="imggs">
                <el-image
                  :src="this.$config.imgIps + item.dataProject.url"
                  :preview-src-list="imgList"
                  class="imgs"
                ></el-image>
              </div>
            </div>
          </el-card>
        </el-timeline-item>
      </el-timeline>
    </div>
  </div>
</template>

<script>
import { loadChart } from "./chart/xmjsChart";
import { loadProjectChart } from "./chart/projectData";
import { loadCircleChart } from "./chart/circleData";
import { mapGetters } from "vuex";
import {
  getScreenV2findDataProjectProgressById,
  findDataProjectProgressBydataProjectId
} from "@/api/base";
export default {
  computed: {
    ...mapGetters(["graphic"])
  },
  watch: {
    graphic() {
      this.list = [];
      this.clearChart();
      this.loadData();
    }
  },
  data() {
    return {
      list: [],
      imgList: [],
      chart: null,
      chart1: null,
      chart2: null,
      chart3: null
    };
  },
  mounted() {
    this.initChart();
    this.loadData();
  },
  methods: {
    initChart() {
      this.chart = this.$echarts.init(this.$refs.chart);
      this.chart1 = this.$echarts.init(this.$refs.chart1);
      this.chart2 = this.$echarts.init(this.$refs.chart2);
      this.chart3 = this.$echarts.init(this.$refs.chart3);
      window.addEventListener("resize", () => {
        this.chart.resize();
        this.chart1.resize();
        this.chart2.resize();
        this.chart3.resize();
      });
    },
    loadData() {
      findDataProjectProgressBydataProjectId({
        id: this.graphic.id
      }).then(res => {
        let datas = res.data;
        let sjData1 = [];
        let date = [];
        let sjData = [];
        datas.map(it => {
          if (it.month < 10) {
            date.push(it.year + "-0" + it.month);
          } else {
            date.push(it.year + "-" + it.month);
          }
          sjData.push(it.completion);
          sjData1.push(it.investPercent);
        });
        let fontSizes2;
        if (document.documentElement.offsetWidth <= 1280) {
          fontSizes2 = 10;
          loadChart(this.chart, { date, sjData, sjData1 }, fontSizes2);
        } else {
          fontSizes2 = 12;
          loadChart(this.chart, { date, sjData, sjData1 }, fontSizes2);
        }
      });
      getScreenV2findDataProjectProgressById({
        id: this.graphic.id
      }).then(res => {
        this.list = res.data;
        res.data.map(it => {
          if (it.dataProject.url != null) {
            this.imgList.push(this.$config.imgIps + it.dataProject.url);
          }
        });
      });
      let data = [
        {
          value: this.graphic.planFundProvince,
          name: "省财政"
        },
        {
          value: this.graphic.planFundCity,
          name: "地方财政"
        },
        {
          value: this.graphic.planFundOther,
          name: "其他"
        }
      ];
      let fontSizes;
      if (document.documentElement.offsetWidth <= 1280) {
        fontSizes = 10;
        loadCircleChart(this.chart1, data, fontSizes);
      } else {
        fontSizes = 14;
        loadCircleChart(this.chart1, data, fontSizes);
      }
      let fontSizes1;
      if (document.documentElement.offsetWidth <= 1280) {
        fontSizes1 = 10;
        loadProjectChart(
          this.chart2,
          this.graphic.completion / 100,
          "进度",
          [
            {
              offset: 1,
              color: "rgba(38,68,127, 1)"
            },
            {
              offset: 0.5,
              color: "rgba(38,68,127, 1)"
            },
            {
              offset: 0,
              color: "rgba(38,68,127, 1)"
            }
          ],
          [
            {
              offset: 0,
              color: "rgba(69,75,240, 1)"
            },
            {
              offset: 0.5,
              color: "rgba(69,75,240, 1)"
            },
            {
              offset: 1,
              color: "rgba(69,75,240, 1)"
            }
          ],
          [
            {
              offset: 1,
              color: "rgba(57,143,245, 1)"
            },
            {
              offset: 0.5,
              color: "rgba(31,194,250, 1)"
            },
            {
              offset: 0,
              color: "rgba(52,250,255, 1)"
            }
          ],
          fontSizes1
        );
      } else {
        fontSizes1 = 15;
        loadProjectChart(
          this.chart2,
          this.graphic.completion / 100,
          "进度",
          [
            {
              offset: 1,
              color: "rgba(38,68,127, 1)"
            },
            {
              offset: 0.5,
              color: "rgba(38,68,127, 1)"
            },
            {
              offset: 0,
              color: "rgba(38,68,127, 1)"
            }
          ],
          [
            {
              offset: 0,
              color: "rgba(69,75,240, 1)"
            },
            {
              offset: 0.5,
              color: "rgba(69,75,240, 1)"
            },
            {
              offset: 1,
              color: "rgba(69,75,240, 1)"
            }
          ],
          [
            {
              offset: 1,
              color: "rgba(57,143,245, 1)"
            },
            {
              offset: 0.5,
              color: "rgba(31,194,250, 1)"
            },
            {
              offset: 0,
              color: "rgba(52,250,255, 1)"
            }
          ],
          fontSizes1
        );
      }

      loadProjectChart(
        this.chart3,
        this.graphic.investPercent / 100,
        "投资",
        [
          {
            offset: 1,
            color: "rgba(38,68,127, 1)"
          },
          {
            offset: 0.5,
            color: "rgba(38,68,127, 1)"
          },
          {
            offset: 0,
            color: "rgba(38,68,127, 1)"
          }
        ],
        [
          {
            offset: 0,
            color: "rgba(239,115,25, 1)"
          },
          {
            offset: 0.5,
            color: "rgba(239,115,25, 1)"
          },
          {
            offset: 1,
            color: "rgba(239,115,25, 1)"
          }
        ],
        [
          {
            offset: 1,
            color: "rgba(233,90,12, 1)"
          },
          {
            offset: 0.5,
            color: "rgba(243,147,9, 1)"
          },
          {
            offset: 0,
            color: "rgba(254,202,5, 1)"
          }
        ],
        fontSizes
      );
    },
    clearChart() {
      this.chart.clear();
      this.chart1.clear();
      this.chart2.clear();
      this.chart3.clear();
    }
  },
  destroyed() {
    this.chart.dispose();
    this.chart1.dispose();
    this.chart2.dispose();
    this.chart3.dispose();
  }
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/styl/varibles.styl'
.bottom
  height calc(100% - 166px)
.navTitle
  position relative
.iconImg
  height 25px
.navName
  position absolute
  color #fff
  font-size 13px
  vertical-align top
  line-height 25px
  left 30px
.jdChart
  width 100%
  height 100%
.areaText
  padding 0 5px
  height calc(50% - 15px)
  margin-top 10px
  overflow-y auto
  width calc(100% - 10px)
  >>>.el-card
    color #fff
    background rgba(10, 37, 80, 0.7)
    border 0px #0B4378 solid
  >>>.el-timeline-item__tail
    border-left 2px solid #0592B3
  >>>.el-timeline-item__node
    background-color #075B80
    box-shadow 0 0 12px #01e1fb inset
  >>>.el-timeline-item__node--normal
    left -3px
    width 15px
    height 15px
  >>>.el-timeline-item__timestamp
    color #fff
    line-height 1
    font-size 15px
    display none
  >>>.el-card__body
    padding 2px
    display flex
    flex-wrap wrap
    align-items center
  >>>.el-timeline-item
    padding-bottom 10px
  &::-webkit-scrollbar
    width 3px
  /* 定义滚动条轨道 内阴影+圆角 */
  &::-webkit-scrollbar-track
    -webkit-box-shadow inset 0 0 6px transparent
    background-color transparent
  /* 定义滑块 内阴影+圆角 */
  &::-webkit-scrollbar-thumb
    border-radius 10px
    -webkit-box-shadow inset 0 0 6px transparent
    background-color $textColor
  /* 定义最上方和最下方的按钮 */
  &::-webkit-scrollbar-button
    height 0
.imgs
  height 100%
.imggs
  width 31%
  height 0.6rem
.imgArr
  width 100%
  justify-content space-between
.wzDiv
  background rgba(8, 56, 93, 0.8)
  box-shadow 0px 0px 5px #08375D inset
  border 1px #08375D solid
  width 100%
  padding 5px
  margin 10px 0
.jdtDiv
  width 100%
  font-size 14px
.jdt
  width calc(100% - 90px)
  margin-left 10px
  height 100%
  justify-content center
  >>>.el-progress
    width 100%
    display flex
    justify-content space-around
    align-items center
  >>>.el-progress-bar__outer
    height 10px !important
  >>>.el-progress-bar
    width 80% !important
    padding-right 0px
    margin 0
  >>>.el-progress__text
    color #fff
  >>>.el-progress-bar__outer
    background-color rgba(0, 0, 0, 0) !important
    border 1px #1B9BFF solid
  >>>.el-progress-bar__inner
    left 1% !important
    top 20% !important
    height 60% !important
    background url('~images/index/home/jd.png')
    background-color #1192E9
    background-repeat repeat-x
  >>>.el-progress__text
    color #0ff
    font-family 'electronicFont'
    font-size 20px !important
.xmjd
  height 30%
@media (max-width 1280px)
  .wzDiv
    width calc(100% - 10px)
    height calc(100% - 6px)
    padding 3px 5px
    font-size 0.08rem
    line-height 16px
    margin 3px 0
  .areaText>>>.el-timeline-item__timestamp
    font-size 0.1rem
  .areaText>>>.el-timeline-item__wrapper
    padding-left 16px
  .areaText>>>.el-timeline-item__node--normal
    left -0.5px
    width 10px
    height 10px
  .xmjd
    height 40%
  .areaText
    height calc(40% - 15px)
  .jdtDiv
    font-size 0.08rem
  .jdt
    width calc(100% - 68px)
    margin-left 3px
    >>>.el-progress__text
      font-size 0.11rem !important
      margin-left 5px !important
</style>
